import { Form } from "react-bootstrap";
import Coin from '../../../../../assets/images/btc.png';
import CommonButton from "../../../../../components/common/commonButton/CommonButton";
const StepTwo = ({ onNext }: { onNext: () => void }) => {
    return (
        <>
            <div className="stake_confirm">
                <h2>Confirm SBTC destination</h2>
                <ul className="common_listing">
                    <li><span>Address</span> <div><span>8241de03e1419195CEIE909CEE063850b3</span></div></li>
                    <li><span>Network</span> <div> <img src={Coin} alt="" /> <span>Bitcoin</span></div></li>
                </ul>
                <Form.Check
                    className="stake_confirm_check"
                    type="checkbox"
                    id="confirm"
                    label="I confirm all BTC deposited will be bridged to SBTC and owned
                    by the above address on the specified network. Errors in the
                    address or network cannot be corrected later."
                />
                <CommonButton title="Confirm" fluid onClick={onNext} />
            </div>
        </>
    );
};
export default StepTwo;
